import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';

export interface LieferungPosition {
    kNr: number;
    lNr: string;
    rNr: string;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posMenge: number;
    posAMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    lArt: string;
    offen: number;
    aktion: number;
    lagAb: boolean;
    abrech: boolean;

    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export interface LieferungPositionFilter {
    lNrList?: string[];
    kNr?: number;
    lNr?: string;
    pos?: number;
}

export const defaultLieferungPosition: LieferungPosition = {
    kNr: 0,
    lNr: '',
    rNr: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: -1, // -1 = new
    posText: '',
    posEinh: '',
    posMenge: 0,
    posAMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 20,
    posBrutto: 0,
    posBem: '',
    lArt: '',
    offen: 0,
    aktion: 0,
    lagAb: false,
    abrech: false,
};

export function useLieferungPositionList(
    filter: LieferungPositionFilter,
    apiOptions?: UseApiOptions<LieferungPosition[]>,
): QueryResult<LieferungPosition[]> {
    return useApi<LieferungPosition[]>(Controller.lieferungPosition + '/list', { filter }, apiOptions);
}

interface AddLieferungPositionResult {
    newNr: number;
}

export async function addLieferungPosition(lieferungPosition: LieferungPosition): Promise<AddLieferungPositionResult> {
    return callApi<AddLieferungPositionResult>(Controller.lieferungPosition + '/add', { lieferungPosition });
}

export async function updateLieferungPosition(lieferungPosition: LieferungPosition): Promise<void> {
    return callApi<void>(Controller.lieferungPosition + '/update', { lieferungPosition });
}

export async function deleteLieferungPosition(lieferungPosition: LieferungPosition): Promise<void> {
    return callApi<void>(Controller.lieferungPosition + '/delete', { lieferungPosition });
}

export async function moveUpLieferungPosition(lNr: string, pos: number): Promise<void> {
    return callApi<void>(Controller.lieferungPosition + '/moveup', {
        lieferungPosition: {
            lNr,
            pos,
        },
    });
}

export async function changeLieferungPositionMenge(lieferungPosition: LieferungPosition): Promise<void> {
    return callApi<void>(Controller.lieferungPosition + '/changeMenge', { lieferungPosition });
}
